import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { StateService } from '../shared/state.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '../shared/utils.service';
import { Logger } from '@app/core';
import { CookieService } from 'ng2-cookies';
import { ValueService } from '@app/login/value.service';
import { Subscription } from 'rxjs';
import { ClientResources } from '@app/client-resources.service';

declare const $: any;
const log = new Logger('PublicComponent');

@Component({
  selector: 'app-public',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PublicLayoutComponent implements OnInit {
  language: string;
  clientId: string;
  registerUrl: string;
  bineAiVenitMobile = false;
  isDocheaven = false;
  clientIsTpp: boolean;
  clientGuardianRole: boolean;
  clientIsDefault: boolean;
  cookieStep = 1;
  checkBoxPromotions = false;
  checkBoxStatistics = false;
  showText = false;
  showText2 = false;

  subscription: Subscription;
  showInfo: boolean;
  os: string;

  fullFooterOpened = false;

  constructor(
    private router: Router,
    private clientResources: ClientResources,
    private translate: TranslateService,
    private stateService: StateService,
    private cookieService: CookieService,
    private valueService: ValueService
  ) {
    this.os = UtilsService.browserOsVersion().os;
    // subscribe to login component messages
    this.subscription = this.valueService.getValue().subscribe((value) => {
      if (value) {
        this.showInfo = value;
      } else {
        this.showInfo = false;
      }
    });

    if (this.cookieService.get('TC_STATUS') === 'true' && this.cookieService.get('TC_PRIVACY_CENTER') !== '') {
      this.cookieStep = 0;
    }

    log.info('init');
    if (this.router.url === '/') {
      this.router.navigate(['errorPage']);
    }

    this.clientId = 'bcrgeorgeclient';
    this.language = this.translate.currentLang;
    this.registerUrl = this.clientResources.getGeorgeUrl() + '/register';

    if (this.clientId === 'docheavenCOL') {
      this.bineAiVenitMobile = true;
    }

    this.isDocheaven = ['docheaven', 'docheavenAD', 'docheavenCOL', 'docheavenMobile'].indexOf(this.clientId) >= 0;
    this.clientIsTpp = this.stateService.getClientIsTpp();
    this.clientGuardianRole = 'guardianrole'.indexOf(this.clientId) >= 0;
    this.clientIsDefault =
      ['bcrgeorgeclient', 'Dateio', 'MMP', 'signClient'].indexOf(this.clientId) < 0 &&
      !this.isDocheaven &&
      !this.clientIsTpp &&
      !this.clientGuardianRole;
  }

  public ngOnInit() {
    this.addHeightPercentageIfMobile();
  }

  shouldShow(input: string) {
    const url = this.router.url.substr(1).split('#')[0].split('?')[0];
    return this.translate.instant(input) !== url;
  }

  changeLanguage() {
    if (this.language === 'ro-RO') {
      this.translate.use('en-US');
      this.language = 'en-US';
    } else {
      this.translate.use('ro-RO');
      this.language = 'ro-RO';
    }
  }

  showBrowserWarning(): boolean {
    let updatedBrowser = false;
    const value = {
      browser: UtilsService.browserOsVersion().browser,
      version: UtilsService.browserOsVersion().browserMajorVersion,
      mobile: UtilsService.browserOsVersion().mobile,
    };
    const browsers = {
      chrome: 68,
      safari: 11,
      ie: 11,
      firefox: 61,
      edge: 42,
      opera: 55,
    };
    if (this.clientId === 'bcrgeorgeclient' && !value.mobile) {
      switch (value.browser) {
        case 'Chrome':
          updatedBrowser = browsers.chrome - value.version > 4;
          break;
        case 'Firefox':
          updatedBrowser = browsers.firefox - value.version > 1;
          break;
        case 'Edge':
          updatedBrowser = browsers.edge - value.version > 1;
          break;
        case 'Opera':
          updatedBrowser = browsers.opera - value.version > 1;
          break;
        case 'Safari':
          updatedBrowser = browsers.safari - value.version > 2;
          break;
        case 'Ie':
          updatedBrowser = browsers.ie !== value.version;
          break;
      }
    }
    return updatedBrowser;
  }

  //  Cookie
  acceptAllCookieSettings(): void {
    this.cookieStep = 0;
    this.setCookie('TC_STATUS', 'true');
    const d = new Date();

    this.setCookie('TC_PRIVACY', `0@041@21,22@20@${d.getTime()}@`);
    this.setCookie('TC_PRIVACY_CENTER', '22,21');
  }

  changeCookieSettings(): void {
    this.cookieStep = 2;
  }

  saveCookieSettings(): void {
    this.cookieStep = 0;
    this.setCookie('TC_STATUS', 'true');

    const d = new Date();

    let userAgreements = `0@041@@20@${d.getTime()}@`;
    this.setCookie('TC_PRIVACY', userAgreements);
    this.setCookie('TC_PRIVACY_CENTER', '');

    if (this.checkBoxPromotions) {
      userAgreements = `0@041@22@20${d.getTime()}@`;
      this.setCookie('TC_PRIVACY', userAgreements);
      this.setCookie('TC_PRIVACY_CENTER', '22');
    }

    if (this.checkBoxStatistics) {
      userAgreements = `0@041@21@20${d.getTime()}@`;
      this.setCookie('TC_PRIVACY', userAgreements);
      this.setCookie('TC_PRIVACY_CENTER', '21');
    }

    if (this.checkBoxPromotions && this.checkBoxStatistics) {
      userAgreements = `0@041@21%2C22${d.getTime()}@`;
      this.setCookie('TC_PRIVACY', userAgreements);
      this.setCookie('TC_PRIVACY_CENTER', '21%2C22');
    }
  }

  setCookie(cookieName: string, cookieValue: string) {
    const date = new Date();
    date.setTime(date.getTime() + 34186669 * 1000);

    this.cookieService.set(
      cookieName,
      cookieValue,
      date,
      '/',
      window.location.hostname === 'localhost' ? '' : 'bcr.ro'
    );
  }

  clickCheckBoxPromotions(): void {
    this.checkBoxPromotions = true;
  }

  clickCheckBoxStatistics(): void {
    this.checkBoxStatistics = true;
  }

  toggleText(): void {
    this.showText = !this.showText;
  }

  toggleText2(): void {
    this.showText2 = !this.showText2;
  }

  get isMobileWidth() {
    return window.innerWidth <= 460;
  }

  returnUrl(url: string) {
    return this.translate.instant(url);
  }

  addHeightPercentageIfMobile() {
    if (this.clientId === 'bcrgeorgeclient') {
      if (UtilsService.browserOsVersion().os === 'IOS' || UtilsService.browserOsVersion().os === 'Android') {
        $('#sfy_full-wrapper').css('height', '100%');
      }
    }
  }

  openPlayStore() {
    window.location.href = 'https://play.google.com/store/apps/details?id=ro.bcr.georgego';
  }

  openFullPage() {
    this.fullFooterOpened = !this.fullFooterOpened;
  }
}
